//로그인, 회원가입, 회원탈퇴
import qs from 'qs';
import { instance, authInstance } from '@/api/index';
import store from '@/store';

function postForm(url, v) {
  // instance.defaults.headers.post['Content-Type'] =
  //   'application/x-www-form-urlencoded';

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  return instance.post(url, qs.stringify(v), config);
}
export { postForm };

function postJson(url, v) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return instance.post(url, v, config);
}

function postAuthJson(url, v = {}, config = {}) {
  // const config = {
  //   headers: {
  //     'Content-Type': 'application/json',
  //   },
  // };
  return authInstance.post(url, v, config);
}
export { postJson, postAuthJson };

function postMultipart(url, v) {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data; boundary=' + new Date().getTime(),
    },
  };

  return authInstance.post(url, v, config);
}
export { postMultipart };

function getMultipart(url, v) {
  const config = {
    params: v,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',
  };
  //return instance.get(url, v, config);
  return authInstance.get(url, config).catch(error => {
    if (error.message.toLowerCase().indexOf('error') != -1) {
      store.dispatch('LOGOUT', store.getters.tenantKey);
    }

    if (error.response.status === 401) {
      //console.log(error.response);
      ///console.log(store.getters.tenantKey);
      store.dispatch('LOGOUT', store.getters.tenantKey);
    } else {
      alert(error.message);
    }
  });
}
export { getMultipart };

function getJson(url, v) {
  const config = {
    params: v,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  //return instance.get(url, v, config);
  return instance.get(url, config);
}

function getAuthJson(url, v) {
  const config = {
    params: v,
    headers: {
      'Content-Type': 'application/json',
    },
  };
  //return instance.get(url, v, config);
  return authInstance.get(url, config);
}
export { getJson, getAuthJson };

export const url = url => `api/v1/${store.getters.tenantKey}${url}`;

export const getEncryption = () =>
  new Promise((resolve, reject) => {
    try {
      getJson(url('/login/encryption'), {}).then(({ data }) => {
        resolve(data);
      });
    } catch (error) {
      reject(error);
    }
  });

export const API = new Proxy(
  {
    postForm,
    postJson,
    getAuthJson,
    postMultipart,
    getJson,
    postAuthJson,
    getMultipart,
  },
  {
    get(target, key) {
      if (!store.getters.tenantKey) throw new Error(`not found tenantKey`);

      return (url, v) =>
        target[key](`api/v1/${store.getters.tenantKey}${url}`, v);
    },
  },
);

export function downloadResposne(response) {
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: response.headers['content-type'] }),
  );
  const link = document.createElement('a');
  link.href = url;
  console.log(response);
  const condispos = response.headers['content-disposition'];
  let filename = 'unknown';

  if (condispos) {
    const [fnm] = condispos.split(';').filter(str => str.includes('filename'));
    if (fnm) [, filename] = fnm.split('=');
    filename = decodeURIComponent(filename);
  }

  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
}
